import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchButton',
  props: {
    value: { type: Boolean },
    disabled: { type: Boolean },
    switchText: null,
    size: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: boolean): void;}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean
  disabled?: boolean
  switchText?: string
  size?: string
};





const checked = computed({
  get() {
    return props.value
  },
  set(val: boolean) {
    emit("input", val)
  }
})


return { __sfc: true,emit, props, checked }
}

})